<template>
  <div>
    <ViewDocumentModal
      v-on:close-modal="modalToggle"
      v-bind:modalContent="modalContent"
      v-bind:modal="modal"
    />
    <div class="container container-dashboard">
      <div class="title">
        <h2>{{ subCategoryName }}</h2>
      </div>
      <table>
        <!-- Table index -->
        <tr class="category-index">
          <th class="view-name">
            <i class="far fa-arrow-down"></i>
            <p>Name:</p>
          </th>
          <th class="view-type">
            <i class="far fa-arrow-down"></i>
            <p>Type:</p>
          </th>
          <th class="view-date">
            <i class="far fa-arrow-down"></i>
            <p>Date:</p>
          </th>
          <th class="view-created-by">
            <i class="far fa-arrow-down"></i>
            <p>Uploaded By:</p>
          </th>
          <th class="view-url"></th>
        </tr>
        <!-- Table data -->

        <tr
          class="category category-wrap"
          v-for="doc in docs"
          v-bind:key="doc.id"
          @click="openModal(doc)"
        >
          <router-link class="subCategory" :to="{}">
            <td class="view-name">
              <p>{{ doc.name }}</p>
            </td>
            <td class="view-type" v-if="doc.type === 'application/pdf'">
              <i class="fad fa-file-pdf"></i>
              <p>PDF</p>
            </td>
            <td
              class="view-type"
              v-else-if="
                doc.type ===
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
              "
            >
              <i class="fad fa-file-word"></i>
              <p>Word</p>
            </td>
            <td class="view-type" v-else-if="doc.type === 'application/csv'">
              <i class="fad fa-file-csv"></i>
              <p>Excel</p>
            </td>
            <td class="view-type" v-else>
              <i class="fad fa-globe"></i>
              <p>URL</p>
            </td>
            <td class="view-date">
              <p>{{ doc.uploadedOn.toDateString() }}</p>
            </td>
            <td class="view-created-by">
              <p>{{ doc.createdby }}</p>
            </td>
            <td class="view-url url">
              <a v-if="doc.url" class="wrap" target="_blank" :href="doc.url">
                <i class="fad fa-download"></i>
              </a>
              <div v-if="isAdmin" class="wrap delete">
                <i
                  @click="deleteDocument(doc.doc)"
                  class="fad fa-trash-alt delete-icon"
                ></i>
              </div>
            </td>
          </router-link>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import db from "../../firebase/init";
import firebase from "firebase/app";
import ViewDocumentModal from "./ViewDocumentModal";
import { getSecondaryCategoryNameOffId } from "../../mixins/getSecondaryCategoryNameOffId";
import { getUserNameOffId } from "../../mixins/getUserNameOffId";
import { getUserInfo } from "../../mixins/getUserInfo";
export default {
  name: "ViewSubCategoryDocuments",
  components: {
    ViewDocumentModal,
  },
  data() {
    return {
      subCategoryName: null,
      categoryId: null,
      docs: [],
      modal: false,
      modalContent: [],
    };
  },
  mixins: [getSecondaryCategoryNameOffId, getUserNameOffId, getUserInfo],
  created() {
    // Fetching data when entrting this instance.
    this.fetchData();
    console.log("this is the view page");
    // using a mixin function to fetch the category name
    // based on the url parameter category ID
    this.fetchSecondaryCategoryName(this.$route.params.secondaryId);
    this.categoryId = this.$route.params.categoryId;
  },
  methods: {
    // Modal toggler
    modalToggle() {
      this.modal = !this.modal;
    },

    // Click event is placed on each table row. Once
    // clicked we pass this function the entire doc
    // array. Creating a new array and sedning it to
    // the modal content array to be shown on the page.
    openModal(doc) {
      if (
        event.target.className === "fad fa-download" ||
        event.target.className === "view-url url" ||
        event.target.className === "wrap delete" ||
        event.target.className === "fad fa-trash-alt delete-icon"
      ) {
        // do nothing
      } else {
        this.modal = !this.modal;
        this.modalContent = [];
        const data = {
          categoryName: this.subCategoryName,
          name: doc.name,
          date: doc.uploadedOn,
          url: doc.url,
          createdby: doc.createdby,
          type: doc.type,
          docSummary: doc.docSummary,
          docLinks: doc.docLinks,
        };
        this.modalContent.push(data);
      }
    },

    async deleteDocument(id) {
      alert("About to delete document. Continue?");
      alert("This cannot be undone. Continue?");
      const ref = await db.collection("documents").doc(`${id}`);
      const category = await db.collection("category").doc(this.categoryId);
      const decrease = firebase.firestore.FieldValue.increment(-1);
      ref.delete().then(() => {
        category.update({
          items: decrease,
        });
      });
    },

    // Fetching documents for the current category selected
    // Once obtained, each item is pushed onto the collection
    // array then irritated through and appended to page.
    fetchData() {
      db.collection("documents")
        .where("secondaryId", "==", this.$route.params.secondaryId)
        .onSnapshot((snap) => {
          snap.docChanges().forEach(async (doc) => {
            if (doc.type === "added") {
              const data = {
                doc: doc.doc.id,
                name: doc.doc.data().name,
                type: doc.doc.data().type,
                createdby: await this.fetchName(doc.doc.data().userid),
                uploadedOn: await doc.doc.data().createdAt.toDate(),
                url: doc.doc.data().url,
                docSummary: doc.doc.data().docSummary,
                docLinks: doc.doc.data().docLinks,
              };
              this.docs.push(data);
            } else if (doc.type === "modified") {
              const data = {
                doc: doc.doc.id,
                name: doc.doc.data().name,
                type: doc.doc.data().type,
                createdby: await this.fetchName(doc.doc.data().userid),
                uploadedOn: await doc.doc.data().createdAt.toDate(),
                url: doc.doc.data().url,
                docSummary: doc.doc.data().docSummary,
                docLinks: doc.doc.data().docLinks,
              };
              this.docs.push(data);
            } else if (doc.type === "removed") {
              this.docs = this.docs.filter((docu) => {
                return docu.doc != doc.doc.id;
              });
            }
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;

  tr {
    display: flex;
  }
  .category-wrap {
    padding: 0 32px;
    text-decoration: none;
    display: flex;

    &:hover {
      color: white;
    }
  }

  td {
    padding: 24px 0;
  }

  th {
    text-align: left;
  }

  .view-name,
  .view-type,
  .view-date,
  .view-created-by {
    display: flex;
    flex: 2;
  }

  .view-type {
    i.fad {
      margin-right: 0.5rem;
    }
  }

  .view-url {
    display: flex;
    flex: 1;
    justify-content: flex-end;

    i {
      margin-left: 16px;
    }

    i:hover {
      color: white;
    }
  }
}
.subCategory {
  text-decoration: none;
  color: black;
  display: flex;
  width: 100%;

  &:hover {
    color: white;
  }
}
</style>
